import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { addUserMessage } from "../redux/slice";
import {
  deleteDeerFlowInstanceThread,
  postDeerFlowThreadMessage,
} from "../redux/actions";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectSelectedInstanceThread } from "../redux/selectors";

export const useDeerFlowChat = () => {
  const dispatch = useAppDispatch();
  const selectedThread = useAppSelector(selectSelectedInstanceThread);
  const [userMessage, setUserMessage] = useState<string>("");

  const handleChangeUserMessage = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setUserMessage(e.target.value);
  };

  const handleSendMessage = useCallback(() => {
    setUserMessage("");
    dispatch(addUserMessage(userMessage));
    dispatch(postDeerFlowThreadMessage(userMessage));
  }, [userMessage]);

  const handleSendKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.ctrlKey && event.key === "Enter") {
        event.preventDefault();
        handleSendMessage();
      }
    },
    [userMessage, dispatch],
  );

  const handleDeleteThread = useCallback(() => {
    if (selectedThread) {
      dispatch(deleteDeerFlowInstanceThread(selectedThread));
    }
  }, [selectedThread]);

  return {
    userMessage,
    handleSendKeyDown,
    handleDeleteThread,
    handleChangeUserMessage,
    handleSendMessage,
  };
};
